<template>
    <div class="vuetify-wrapper">
        <appointment-creator
            :appointment="JSON.parse(appointment)"
            :pharmacy="JSON.parse(pharmacy)"
            @fetch-appointments="save"
        ></appointment-creator>
    </div>
</template>

<script>
import AppointmentCreator from '../appointments/AppointmentCreator.vue';

export default {
    components: {
        AppointmentCreator
    },
    props: {
        appointment: String,
        pharmacy: String
    },
    methods: {
        save() {
            window.location.reload()
        }
    }
}
</script>

<style></style>